module.exports = __webpack_public_path__ + "static/media/majetok.b4d1b8ce.png";